module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-red-ac9a536fdf4bcec3ef87a29e3e9deffd.png";